import * as THREE from 'three'
var updateShadowCamera;

  export var Lights = function (scene, floorplan, camera?) {

    var scope = this;
    var scene = scene;
    var floorplan = floorplan;
    var camera = camera;

    var tol = 1;
    var baseHeight = 320;

    var hemiLight;
    var ambientLight;
    var dirLight;
    var fillLight;

    var brightness = 1.0;
    var baseIntensity = {
      hemi: 0.75,
      ambient: 0.32,
      directional: 2.0,
      fill: 0.5
    };

    this.getDirLight = function () {
      return dirLight;
    }

    this.getBrightness = function() {
      return brightness;
    }

    this.setBrightness = function(value) {
      var next = Number(value);
      if (!isFinite(next)) {
        return;
      }
      brightness = Math.min(1.5, Math.max(0.0, next));
      applyBrightness();
      if (dirLight && dirLight.shadow) {
        dirLight.shadow.needsUpdate = true;
      }
      scene.needsUpdate = true;
    }

    function applyBrightness() {
      if (!hemiLight || !ambientLight || !dirLight || !fillLight) {
        return;
      }

      hemiLight.intensity = baseIntensity.hemi * brightness;
      ambientLight.intensity = baseIntensity.ambient * brightness;
      dirLight.intensity = baseIntensity.directional * brightness;
      fillLight.intensity = baseIntensity.fill * brightness;
    }

    function init() {
      hemiLight = new THREE.HemisphereLight(0xe8f0ff, 0x7d8792, baseIntensity.hemi);
      hemiLight.position.set(0, baseHeight, 0);
      scene.add(hemiLight);

      ambientLight = new THREE.AmbientLight(0xffffff, baseIntensity.ambient);
      scene.add(ambientLight);

      dirLight = new THREE.DirectionalLight(0xfff2d6, baseIntensity.directional);
      dirLight.castShadow = true;
      dirLight.visible = true;

      var shadowMapSize = (window.devicePixelRatio && window.devicePixelRatio > 1.25) ? 2048 : 1024;
      dirLight.shadow.mapSize.set(shadowMapSize, shadowMapSize);
      dirLight.shadow.bias = -0.00008;
      dirLight.shadow.normalBias = 0.02;
      dirLight.shadow.radius = 1.6;
      dirLight.shadow.camera.near = 1;
      dirLight.shadow.camera.far = baseHeight * 5;

      scene.add(dirLight);
      scene.add(dirLight.target);

      fillLight = new THREE.DirectionalLight(0xc4d8ff, baseIntensity.fill);
      fillLight.castShadow = false;
      scene.add(fillLight);
      scene.add(fillLight.target);

      applyBrightness();
      floorplan.fireOnUpdatedRooms(updateShadowCamera);
      updateShadowCamera();
    }

    this.updateShadowCamera = function(cameraOverride?) {
      var size = floorplan.getSize();
      var d = Math.max((Math.max(size.z, size.x) + tol) / 2.0, 220);

      var center = floorplan.getCenter();
      var lightHeight = Math.max(baseHeight, d * 0.9);
      var activeCamera = cameraOverride || camera;
      var sunPos = new THREE.Vector3();

      // Keep shadows intuitive while orbiting by aligning key light with camera direction.
      if (activeCamera && activeCamera.position) {
        var camToCenter = new THREE.Vector3().subVectors(center, activeCamera.position);
        var camRight = new THREE.Vector3().crossVectors(camToCenter, new THREE.Vector3(0, 1, 0));

        if (camToCenter.lengthSq() < 0.0001) {
          camToCenter.set(-1, -0.35, 1);
        }
        if (camRight.lengthSq() < 0.0001) {
          camRight.set(1, 0, 0);
        }

        camToCenter.normalize();
        camRight.normalize();

        var cameraAlignedOffset = camToCenter.clone().multiplyScalar(-d * 1.35);
        var sideOffset = camRight.multiplyScalar(d * 0.28);
        sunPos.copy(center).add(cameraAlignedOffset).add(sideOffset);
      } else {
        sunPos.set(center.x - d * 0.85, lightHeight, center.z + d * 0.65);
      }

      sunPos.y = lightHeight;

      dirLight.position.copy(sunPos);
      dirLight.target.position.copy(center);

      fillLight.position.set(center.x + d * 0.7, lightHeight * 0.6, center.z - d * 0.55);
      fillLight.target.position.copy(center);

      var range = d * 1.35;
      var cam = dirLight.shadow.camera as THREE.OrthographicCamera;
      cam.left = -range;
      cam.right = range;
      cam.top = range;
      cam.bottom = -range;
      cam.near = 1;
      cam.far = Math.max(lightHeight * 4.5, d * 8);
      cam.updateProjectionMatrix();

      dirLight.shadow.needsUpdate = true;
    }

    updateShadowCamera = this.updateShadowCamera;
    init();
  }
